import { handleActions } from "redux-actions";
import { fromJS } from "immutable";
import types from "../types";

const INITIAL_STATE = fromJS({
  isLoading: false,
  data: [],
});

const reducer = handleActions(
  {
    [types.LIST]: (state) => state.set("isLoading", true),
    [types.LIST_FAIL]: (state) => state.set("isLoading", false),
    [types.LIST_SUCCESS]: (state, { payload: response }) =>
      state.set("isLoading", true).set("data", response.data),
  },
  INITIAL_STATE
);

export default reducer;
